import s from "../clinic.module.css";
import aa from "../AdminPortal/adminApp.module.css";
import { Button, Field, Input, Select, useToast } from "../../ui";
import {
  SPORT_RANK_OPTIONS,
  formatCardDate,
  rankFormError,
  skillLevelLabel,
  sportRankLabel,
  dateTone,
} from "./athleteQualifications";

function toneClass(tone) {
  if (tone === "expired") return aa.rosterBad;
  if (tone === "soon") return aa.rosterSoon;
  if (tone === "ok") return aa.rosterOk;
  return "";
}

export function ClientLevelSection({ edit, setEdit, onSave, editing, onToggleEdit }) {
  const saved = skillLevelLabel(
    edit?.skill_level_kind,
    edit?.skill_level,
    edit?.skill_level_label,
  );
  const current = saved || edit?.rank_belt?.trim() || "";
  const value =
    edit?.skill_level_system === "custom" || edit?.skill_level_label
      ? edit.skill_level_label || ""
      : current;

  return (
    <>
      {editing ? (
        <form
          className={s.clientTabFormStack}
          onSubmit={(e) => {
            e.preventDefault();
            onSave(e);
            onToggleEdit();
          }}
        >
          <Field label="Уровень">
            <Input
              value={value}
              onChange={(e) => {
                const text = e.target.value;
                setEdit({
                  ...edit,
                  skill_level_system: text.trim() ? "custom" : "",
                  skill_level_kind: "",
                  skill_level: "",
                  skill_level_label: text,
                });
              }}
              placeholder="5 гып, 2 кю, жёлтый пояс"
            />
          </Field>
          <Button type="submit" size="sm">
            Сохранить
          </Button>
        </form>
      ) : (
        <dl className={s.clientDl}>
          <dt>Уровень</dt>
          <dd>{current || "Не указан"}</dd>
        </dl>
      )}
    </>
  );
}

export function ClientRankSection({ edit, setEdit, onSave, editing, onToggleEdit }) {
  const toast = useToast();
  const label = sportRankLabel(edit?.sport_rank);
  const orderTone = dateTone(edit?.sport_rank_expires_at);
  const orderText = formatCardDate(edit?.sport_rank_order_date) || "—";
  const untilText = formatCardDate(edit?.sport_rank_expires_at) || "—";

  return (
    <>
      {editing ? (
        <form
          className={s.clientTabFormStack}
          onSubmit={(e) => {
            e.preventDefault();
            const error = rankFormError(edit);
            if (error) {
              toast.error(error);
              return;
            }
            onSave(e);
            onToggleEdit();
          }}
        >
          <Field label="Разряд">
            <Select
              value={edit?.sport_rank || ""}
              onChange={(e) => {
                const sport_rank = e.target.value;
                setEdit({
                  ...edit,
                  sport_rank,
                  ...(sport_rank
                    ? {}
                    : { sport_rank_order_date: "", sport_rank_expires_at: "" }),
                });
              }}
            >
              <option value="">Без разряда</option>
              {SPORT_RANK_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Select>
          </Field>
          <Field
            label="Дата приказа"
            hint="Обязательно, если разряд выбран"
          >
            <Input
              type="date"
              required={!!edit?.sport_rank}
              value={edit?.sport_rank_order_date || ""}
              onChange={(e) =>
                setEdit({ ...edit, sport_rank_order_date: e.target.value })
              }
            />
          </Field>
          <Field label="Срок окончания" hint="Обязательно, если разряд выбран">
            <Input
              type="date"
              required={!!edit?.sport_rank}
              value={edit?.sport_rank_expires_at || ""}
              onChange={(e) =>
                setEdit({ ...edit, sport_rank_expires_at: e.target.value })
              }
            />
          </Field>
          <Button type="submit" size="sm">
            Сохранить
          </Button>
        </form>
      ) : (
        <dl className={s.clientDl}>
          <dt>Разряд</dt>
          <dd>{label || "Не указан"}</dd>
          <dt>Дата приказа</dt>
          <dd>{label ? orderText : "—"}</dd>
          <dt>Срок окончания</dt>
          <dd className={label ? toneClass(orderTone) : ""}>
            {label ? untilText : "—"}
          </dd>
        </dl>
      )}
    </>
  );
}
